import React from 'react';
import './child-safety.css';

const ChildSafety = () => {
  return (
    <div className="csContainer">
      <div className="csHeader">
        <span className="csEyebrow">TailTrace LLC</span>
        <h1>Child Safety Standards</h1>
        <p className="csMeta">
          App: TailTrace &nbsp;·&nbsp; Package: com.tailtrace.app &nbsp;·&nbsp; Last updated: June 2026
        </p>
      </div>

      <hr className="csDivider" />

      <section className="csSection">
        <h2>Our Commitment</h2>
        <p>
          TailTrace LLC is committed to providing a safe environment for all users of the TailTrace
          mobile application. We take child safety with the utmost seriousness and maintain a
          zero-tolerance policy toward any content or behavior that exploits or endangers minors.
        </p>
      </section>

      <section className="csSection">
        <h2>Prohibition of Child Sexual Abuse and Exploitation (CSAE)</h2>
        <p>
          TailTrace LLC strictly and explicitly prohibits Child Sexual Abuse and Exploitation (CSAE)
          in any form on our platform. This includes, but is not limited to:
        </p>
        <ul>
          <li>
            The creation, upload, distribution, or possession of Child Sexual Abuse Material (CSAM)
          </li>
          <li>
            Any grooming, solicitation, or exploitation of minors through our platform or related services
          </li>
          <li>
            Any content, communication, or conduct that sexualizes individuals under the age of 18
          </li>
        </ul>
        <p>
          Any user found to be in violation of this policy will be immediately suspended from the
          platform. Confirmed violations will be reported to the National Center for Missing &amp;
          Exploited Children (NCMEC) and to the appropriate law enforcement authorities.
        </p>
      </section>

      <section className="csSection">
        <h2>In-App Reporting Mechanism</h2>
        <p>
          TailTrace provides users with an in-app mechanism to flag and report content or behavior
          that violates our community standards, including any suspected CSAE. All reports are
          reviewed promptly and actioned in accordance with this policy.
        </p>
      </section>

      <section className="csSection">
        <h2>Addressing Child Sexual Abuse Material (CSAM)</h2>
        <p>
          TailTrace LLC has internal procedures for identifying, removing, and reporting CSAM.
          Upon detection or credible report of CSAM on our platform, we will:
        </p>
        <ul>
          <li>Immediately remove the offending content</li>
          <li>Suspend the responsible account(s)</li>
          <li>
            Report the incident to NCMEC via the CyberTipline and cooperate fully with any
            resulting law enforcement investigation
          </li>
        </ul>
      </section>

      <section className="csSection">
        <h2>Legal Compliance</h2>
        <p>
          TailTrace LLC complies with all applicable child safety laws and regulations, including
          the Children's Online Privacy Protection Act (COPPA), applicable U.S. federal and state
          laws, and all other relevant international child protection standards.
        </p>
      </section>

      <section className="csSection">
        <h2>Child Safety Contact</h2>
        <p>
          To report a child safety concern, suspected CSAE, or any related issue, please contact
          our dedicated child safety point of contact directly:
        </p>
        <div className="csContactCard">
          <p className="csContactLabel">TailTrace Safety Team</p>
          <a href="mailto:tailtracehq@gmail.com" className="csContactEmail">
            tailtracehq@gmail.com
          </a>
          <p className="csContactNote">
            We aim to respond to all child safety reports within 24 hours.
          </p>
        </div>
      </section>
    </div>
  );
};

export default ChildSafety;